import { render, staticRenderFns } from "./adminlist.vue?vue&type=template&id=6a585523&scoped=true&"
import script from "./adminlist.vue?vue&type=script&lang=js&"
export * from "./adminlist.vue?vue&type=script&lang=js&"
import style0 from "./adminlist.vue?vue&type=style&index=0&id=6a585523&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a585523",
  null
  
)

export default component.exports